import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import StripeCardPaymentSection from './StripeCardPaymentSection';
import { MtaPaymentCollectionOption } from '../../../services/api';

interface IProps {
	payInFullOption: MtaPaymentCollectionOption;
	toggleModal: (open: boolean) => void;
}

const StripePaymentWrapper = ({ payInFullOption, toggleModal }: IProps) => {
	const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_KEY ?? '');
	return (
		<Elements stripe={stripePromise}>
			<StripeCardPaymentSection payInFullOption={payInFullOption} toggleModal={toggleModal} />
		</Elements>
	);
};

export default StripePaymentWrapper;
